import { Component, TemplateRef, ViewChild, AfterViewInit } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'formly-wrapper-addons',
    templateUrl: './addon-wrapper.component.html',
    styles: [`
    .mutara-addon {
      cursor: 'pointer'; 
      margin-left: 0.5em; 
      margin-right: 0.2em;
    }`],
    standalone: false
})
export class AddonWrapperComponent extends FieldWrapper implements AfterViewInit {
  @ViewChild('matPrefix') matPrefix: TemplateRef<any> | undefined;
  @ViewChild('matSuffix') matSuffix: TemplateRef<any> | undefined;

  ngAfterViewInit() {
    if (this.matPrefix) {
      Promise.resolve().then(() => this.props.prefix = this.matPrefix);
    }

    if (this.matSuffix) {
      Promise.resolve().then(() => this.props.suffix = this.matSuffix);
    }
  }

  addonRightClick($event: any) {
    if (this.props.addonRight.onClick) {
      this.props.addonRight.onClick(this.props, this, $event);
    }
  }

  addonLeftClick($event: any) {
    if (this.props.addonLeft.onClick) {
      this.props.addonLeft.onClick(this.props, this, $event);
    }
  }
}
